export default {"src":"/_next/static/media/purchasesViewContractIcon.d537818e.svg","height":14,"width":14};